import { c as _c } from "react/compiler-runtime";
import React from 'react';
import AdvancedSearchProductsGrid from '../AdvancedSearchProductsGrid';
import LoadMoreButton from '../AdvancedSearchProductsGrid/LoadMoreButton';

// Grid shown before the first Algolia search completes: the server-fetched
// products with eager images, padded with in-grid placeholders up to
// expectedCount. A `null` product entry also renders as a placeholder, holding
// the slot of a product that can't be pre-rendered so the rest keep their
// final positions. The load-more block matches the one the real grid renders,
// keeping that space reserved so content below doesn't shift on takeover.
const InitialProductsGrid = t0 => {
  const $ = _c(13);
  const {
    products,
    expectedCount,
    showLoadMore,
    onLoadMore,
    isLoadingMore
  } = t0;
  let t1;
  if ($[0] !== expectedCount || $[1] !== products) {
    t1 = products.slice(0, expectedCount);
    $[0] = expectedCount;
    $[1] = products;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const productsToShow = t1;
  const t2 = productsToShow.length;
  const t3 = Math.max(0, expectedCount - productsToShow.length);
  let t4;
  if ($[3] !== productsToShow || $[4] !== t3) {
    t4 = <AdvancedSearchProductsGrid products={productsToShow} eagerImageCount={t2} trailingPlaceholderCount={t3} />;
    $[3] = productsToShow;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isLoadingMore || $[7] !== onLoadMore || $[8] !== showLoadMore) {
    t5 = showLoadMore && <div className="flex justify-center mt-8 mb-12"><LoadMoreButton onClick={onLoadMore} isLoading={isLoadingMore} /></div>;
    $[6] = isLoadingMore;
    $[7] = onLoadMore;
    $[8] = showLoadMore;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div>{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
};
export default InitialProductsGrid;